export default __webpack_public_path__ + "static/media/feature-backup-2.df191048.png";